import type { PropsWithChildren } from "react";

import { IconButton, type IIconsButtonProps } from "@similarweb/ui-components";

import { StyledIconButtonWrapper } from "./styles";

type Props = PropsWithChildren<Pick<IIconsButtonProps, "isDisabled" | "onClick" | "children">>;

const ExcelExportButton = ({ isDisabled, children, onClick }: Props) => {
    return (
        <StyledIconButtonWrapper $isDisabled={isDisabled}>
            <IconButton
                key="button"
                type="flat"
                iconName="upload"
                dataAutomation="export-excel-button"
                isDisabled={isDisabled}
                onClick={onClick}
            >
                {children}
            </IconButton>
        </StyledIconButtonWrapper>
    );
};

export default ExcelExportButton;
